import { render, staticRenderFns } from "./TeamsTable.vue?vue&type=template&id=602c4980&scoped=true&"
import script from "./TeamsTable.vue?vue&type=script&lang=js&"
export * from "./TeamsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c4980",
  null
  
)

export default component.exports